module.exports = __webpack_public_path__ + "static/media/PTSerif-Bold.1e0973a4.ttf";